import Metadata from '@/shared/types/metadata/index.type';
import Response from '@/shared/types/response';
import fetcher from '@/shared/utils/fetcher';
import getCookie from '@/shared/utils/getCookie';

const getMetadata = async (onUnauthorized?: () => void) => {
  const token = getCookie('auth_token');

  try {
    return await fetcher<Response<Metadata>>({
      url: '/products/metadata/template_schemas/',
      method: 'GET',
      token,
      onUnauthorized,
      retries: 0,
    });
  } catch (error) {
    console.error(
      'Error occurred in function "getMetadata" in file "src/shared/api/product/getMetadata.ts":',
      error,
    );
    return error as Response<Metadata>;
  }
};

export default getMetadata;
